import React, { Component } from 'react'
import { withRouter } from 'react-router-dom';
import Select from './../common/select2';
import { HTTPService } from "./../../services/httpService";
import { MENU_ITEMS } from '../../config/navConfig';

const API = new HTTPService();

// Build route-to-label lookup from navConfig
const ROUTE_LABELS = {};
Object.values(MENU_ITEMS).forEach(item => {
  if (item.route) {
    // Use pathname only (strip query string)
    const pathname = item.route.split('?')[0];
    if (!ROUTE_LABELS[pathname]) {
      ROUTE_LABELS[pathname] = { label: item.label, icon: item.icon };
    }
  }
});


class componentName extends Component {

  state = {
    companies : [],
    selectedCo : this.props.title
  }


  readCompanies = async (user) => {
    let companyList = `/userAccess/${user}`;        
    const  { data : companies }  =  await API.get(companyList);
    this.setState({ companies })
  }

  handleCoChange = async (event) => {

    const { value } = event.target;
    if (value !== ""){
    // find the location name in the array of companies and call the onSwitch
    const selectedCompany = this.state.companies.filter(co => co.Installer_Name === value);
    //console.log ("Selected Company : " , selectedCompany);
    //console.log ("user Type : " , this.props.userType);
    
    this.props.onSwitch(selectedCompany[0].Installer_id, this.props.userType);

//    this.setState({ });
    }
}

   async componentDidMount() {

    if ((this.state.companies.length === 0)){
      await this.readCompanies(this.props.userId);
    }
  }

  // Lets count how many companies this user is connected to and if it is more than one, offer the selection as a drop down 
  // if its only 1, then just display it 
  // if they change the selection, then we bounce back up to reset the app with the new selected company 

  // Get the current page label from the route
  getCurrentPageLabel = () => {
    const pathname = this.props.location?.pathname || window.location.pathname;
    const match = ROUTE_LABELS[pathname];
    if (match) return match;
    // Try parent path (e.g. /staff/time-reports -> /staff)
    const parentPath = '/' + pathname.split('/').filter(Boolean)[0];
    return ROUTE_LABELS[parentPath] || null;
  };

  render() {

    var companyName = this.props.title;
    const dispCompanies = this.state.companies.map(co => co.Installer_Name);
    const currentPage = this.getCurrentPageLabel();
    return (
      <React.Fragment>
        <nav className="navbar bg-white shadow-sm navbar-light mb-4 d-none d-lg-block">
          <div className="row align-items-center">
            <div className="col-md-4">
        {this.state.companies.length < 2 && <span className="navbar-brand">{companyName}</span>}
        {this.state.companies.length >= 2 &&
            <Select
                name="location"
                label=" "
                options={dispCompanies}
                value={this.state.selectedCo}
                onChange={this.handleCoChange}
            />}
          </div>
          <div className="col text-center">
            {currentPage && (
              <span className="text-muted" style={{ fontSize: '1.1rem' }}>
                <i className={`${currentPage.icon} mr-2`}></i>
                {currentPage.label}
              </span>
            )}
          </div>
          <div className="col-md-4">
          <span className="navbar-text float-right">{this.props.userName}</span>
          </div>
        </div>
        </nav>
      </React.Fragment>
    )
  }
}

export default withRouter(componentName);
